import React, { FC, PropsWithChildren } from 'react'
import { useCheckoutSizes } from '../../utils/responsive'
import { Heading, Icon, Text, useThemePerClass } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useMerchantDisplayNameOrName } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { useRoutePageName } from '../../config/router'
import { PageNames } from '../../model'

export const SupHeader: FC<PropsWithChildren> = () => {
  const { t } = useTranslation(['financeFee'])
  const { headingSize, textSize } = useCheckoutSizes()
  const themeClass = useThemePerClass(styles)
  const merchantDisplayNameOrName = useMerchantDisplayNameOrName()
  const pageName = useRoutePageName()
  const isSummaryPage = pageName === PageNames.SUMMARY
  return (
    <div className={themeClass.container}>
      <div className={themeClass.iconContainer}>
        <Icon.Afterpay size='Medium' color='White' />
      </div>
      <Heading size={headingSize} testNameSpace='sup-header'>
        {isSummaryPage ? t('summary.header.title') : t('til.header.title')}
      </Heading>
      {isSummaryPage && (
        <div className={themeClass.content}>
          <Text size={textSize} color='Subtle' className={themeClass.subtitle}>
            {t('summary.header.content', { merchantName: merchantDisplayNameOrName })}
          </Text>
        </div>
      )}
    </div>
  )
}
